import { Component, OnInit } from '@angular/core';

import { ResetPasswordService } from '../services/reset-password.service';
import { ErrorService } from '../../shared/services/error.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'login-set-new-password',
    templateUrl: 'set-new-password.component.html'
})

export class LoginSetNewPasswordComponent{

    constructor(
        private _resetPasswordService: ResetPasswordService,
        private _errorService: ErrorService,
        private _layoutService: LayoutService
    ) {
        
    }
    
    ngOnInit() {
    	this._layoutService.setCurrentPage('login-set-new-password');
        this._resetPasswordService.resetError();
        this._resetPasswordService.resetNewPasswordData();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    getBackEndError(){
        return this._errorService.getBackEndError();
    }

    getNewPasswordData(){
        return this._resetPasswordService.getNewPasswordData();
    }

    isLoading(){
        return this._resetPasswordService.isLoading();
    }

    isDisableSubmit(){
        return this._resetPasswordService.isDisableInputNewPassword();
    }

    changePassword(){
        this._resetPasswordService.changePassword();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/set-new-password.component.ts